import { FC, useState } from 'react';
import { StorePerformanceInterval } from '../../../../../../constants';
import { QueueLengthPerformanceItem } from '../../../../../../hooks';
import { ColumnFlexContainer } from '../../../../../../stories/atoms/containerV2/ContainerV2';
import { TillAggregateData } from '../gridView/GridView';
import { TillContainer } from './TillContainer';

export type TillType = 'DEFAULT' | 'SELFCHECKOUT' | 'SCO-MP' | 'null';

type MobileGridProps = {
  interval: StorePerformanceInterval;
  performanceItems: QueueLengthPerformanceItem[];
  filteredPerformanceItems: (QueueLengthPerformanceItem | null)[];
};

export const MobileGrid: FC<MobileGridProps> = ({ interval, performanceItems, filteredPerformanceItems }) => {
  const [isDefaultOpen, setIsDefaultOpen] = useState(false);
  const [isSelfCheckoutOpen, setIsSelfCheckoutOpen] = useState(false);

  const getTillAggregateDataByTillType = (type: TillType) => {
    const tillAggregateDataMap: Map<string, TillAggregateData> = new Map();

    filteredPerformanceItems.forEach((item) => {
      if (!item) return;

      const { timeUnit, tillData } = item;

      tillData.forEach((data) => {
        const { tillId, tillType, queueCount, transactions } = data;

        if (tillType === type) {
          const tillAggregateData = tillAggregateDataMap.get(tillId);

          tillAggregateDataMap.set(tillId, {
            tillId,
            tillType,
            values: !tillAggregateData
              ? {
                  [timeUnit]: { queueCount, transactions },
                }
              : {
                  ...tillAggregateData.values,
                  [timeUnit]: { queueCount, transactions },
                },
          });
        }
      });
    });

    return Array.from(tillAggregateDataMap.values());
  };

  const tillAggregateDataRegularTills = [
    ...getTillAggregateDataByTillType('DEFAULT'),
    ...getTillAggregateDataByTillType('null'),
  ];
  const tillAggregateDataSCOTills = [
    ...getTillAggregateDataByTillType('SELFCHECKOUT'),
    ...getTillAggregateDataByTillType('SCO-MP'),
  ];

  const toggleTillType = (tillType: TillType) => {
    if (tillType === 'DEFAULT') {
      setIsDefaultOpen((prev) => !prev);
    } else {
      setIsSelfCheckoutOpen((prev) => !prev);
    }
  };

  return (
    <ColumnFlexContainer data-testid="mobile-grid-container-wrapper" padding={[4]} gap={[2]} overflow="scroll">
      <TillContainer
        isOpen={isDefaultOpen}
        interval={interval}
        key="DEFAULT"
        tillType="DEFAULT"
        aggregateData={tillAggregateDataRegularTills}
        performanceItems={performanceItems}
        handleOpenTillType={(tillType) => {
          toggleTillType(tillType);
        }}
      />
      <TillContainer
        isOpen={isSelfCheckoutOpen}
        interval={interval}
        key="SELFCHECKOUT"
        tillType="SELFCHECKOUT"
        aggregateData={tillAggregateDataSCOTills}
        performanceItems={performanceItems}
        handleOpenTillType={(tillType) => {
          toggleTillType(tillType);
        }}
      />
    </ColumnFlexContainer>
  );
};
